var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadError"},[_c('div',{staticClass:"sub"},[_c('span',{style:({color:_vm.textColor})},[_vm._v(_vm._s(_vm.loadErrorText))]),_vm._v(" "),_c('p',{staticClass:"cursor",class:{myselfBadge: _vm.btnstyle},style:(_vm.errBtnStyle),on:{"click":_vm.loadAgain}},[_vm._v("点击重试")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681e6ab0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/loadError.vue
// module id = null
// module chunks = 